import script from "./DirectivesIntro.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectivesIntro.vue?vue&type=script&setup=true&lang=ts"

import "./DirectivesIntro.vue?vue&type=style&index=0&id=42395930&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42395930"]])

export default __exports__